import React from 'react'
import { StyledLeasingSummaryText } from './leasing-summary-text.styles'

export const LeasingSummaryText = ({ leasingSummary }: { leasingSummary?: string | null }) => {
    if (!leasingSummary) {
        return null
    }
    return <StyledLeasingSummaryText>{leasingSummary}</StyledLeasingSummaryText>
}
